import { Card, Divider, Empty, message, Skeleton, Tabs, Button } from "antd";
import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ChannelType } from "../../contexts/channels/ChannelProvider";
import {
  PaymentContext,
  PaymentContextProvider,
  PaymentContextType,
} from "../../contexts/payment/PaymentContext";
import { thousandSeparator } from "../../helpers/thousand_separator";
import { ChannelModel } from "../../models/ChannelModel";
import { PaymentInterfaceParam } from "../channels/Channel";
import "./payment.css";
import {
  DonationSingleCartResultInterface,
  DonationSingleResultInterface,
} from "../../contexts/payment/interfaces/donation-single-result.interface";
import axios from "axios";
import { CompanySingleResultInterface } from "../../models/CompanyModel";
import { FileAddOutlined } from "@ant-design/icons";
import { UploadFileProvider } from "../../contexts/upload-file/upload-file.provider";
import { PaymentProvider } from "../../contexts/payment/PaymentProvider";
// import TrxModalComponent from "../components/trx-modal.component.tsx.old";

function PaymentCart() {
  return (
    <PaymentContextProvider>
      <PaymentState />
    </PaymentContextProvider>
  );
}

function PaymentState() {
  const [channel, setChannel] = React.useState<ChannelModel>();
  const {
    initPayment,
    getDonationCartDetailForStatus,
    donationCartDetailForStatus,
  } = React.useContext(PaymentContext) as PaymentContextType;
  const [vaNumber, setVaNumber] = React.useState<string | undefined>(
    "123456789"
  );
  // const [donationResult, setDonationResult] =
  //   React.useState<DonationSingleResultInterface>(undefined);
  const [donationCartResult, setDonationCartResult] =
    React.useState<DonationSingleCartResultInterface>(undefined);
  const location = useLocation();
  const [selectedFile, setSelectedFile] = useState<string>(null);
  const [uploading, setUploading] = useState<boolean>(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [totalAmount, setTotalAmount] = useState<number>(0);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    // Get the selected file from the input
    const file = e.target.files[0];

    const confirm = window.confirm(
      "Apakah anda yakin ingin mengupload bukti transfer ini?"
    );
    if (confirm === true) {
      setUploading(true);
      // You can perform additional actions with the file if needed
      // For example, you might want to upload the file to a server
      const uploadFileProvider = new UploadFileProvider();
      console.log(file);
      const resp = await uploadFileProvider.uploadSingle(file, (progress) => {
        console.log(progress);
      });
      if (resp?.status === true) {
        // update proof of payment
        const paymentProvider = new PaymentProvider();
        const updateProof = await paymentProvider.uploadProofOfPaymentCart(
          donationCartResult?.data[0]?.invoice_code_parent,
          resp.data?.id
        );
        if (updateProof?.status === true) {
          window.alert(
            "Terimakasih sudah mengupload bukti transfer, mohon tunggu transaksi anda sedang diproses oleh sistem kami."
          );
          setSelectedFile(resp.data?.id);
        } else {
          window.alert("Upload bukti transfer gagal");
          setSelectedFile(null);
        }
      }
      setUploading(false);
    }
  };

  // React.useEffect(() => {
  //   window.onpopstate = () => {
  //     cancelPayment(transactionModel?.data?.transaction_details?.order_id!);
  //   };
  // }, [transactionModel]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    console.log("zxczxc", donationCartResult);
    if (donationCartResult) {
      // get donation status every 5 seconds
      const interval = setInterval(() => {
        getDonationCartDetailForStatus(
          donationCartResult?.data[0]?.invoice_code_parent
        );
      }, 5000);
      // Stop the interval when the component unmounts
      return () => clearInterval(interval);
    }
  }, [donationCartResult]);

  React.useEffect(() => {
    if (donationCartResult !== undefined) {
      setTotalAmount(0);
      for (const cart of donationCartResult.data) {
        setTotalAmount((state) => (state += cart.amount + cart.unique_code));
      }
    }
  }, [donationCartResult]);

  React.useEffect(() => {
    if (location) {
      setChannel((location.state as PaymentInterfaceParam)?.item);
      setDonationCartResult(
        (location.state as PaymentInterfaceParam)?.donationCartResult
      );
      console.log(location.state);
    }
  }, [location]);

  React.useEffect(() => {
    if (channel) {
      setVaNumber(channel.account_number);
    }
  }, [channel]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (donationCartResult !== undefined && channel !== undefined) {
      for (const donation of donationCartResult.data) {
        initPayment(donation?.id, channel?.id, "");
      }
    }
  }, [donationCartResult, channel]);

  React.useEffect(() => {
    if (donationCartDetailForStatus !== undefined) {
      if (
        donationCartDetailForStatus?.data?.every(
          (data) => data?.status === "settlement"
        )
      ) {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            console.log(response);
            const url = `${response?.data?.platform_donation}/payment/success?order_id=${donationCartDetailForStatus?.data[0]?.invoice_code}&result=success`;
            window.location.href = url;
          });
      } else if (
        donationCartDetailForStatus?.data?.some(
          (data) => data?.status === "expire"
        )
      ) {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            const url = `${response?.data?.platform_donation}/payment/timeout?order_id=${donationCartDetailForStatus?.data[0]?.invoice_code}&result=expire`;
            window.location.href = url;
          });
      } else if (
        donationCartDetailForStatus?.data?.some(
          (data) => data?.status === "cancel"
        )
      ) {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            const url = `${response?.data?.platform_donation}/payment/failed?order_id=${donationCartDetailForStatus?.data[0]?.invoice_code}&result=expire`;
            window.location.href = url;
          });
      } else if (
        donationCartDetailForStatus?.data?.some(
          (data) => data?.status === "deny"
        )
      ) {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            const url = `${response?.data?.platform_donation}/payment/failed?order_id=${donationCartDetailForStatus?.data[0]?.invoice_code}&result=expire`;
            window.location.href = url;
          });
      }
    }
  }, [donationCartDetailForStatus]);

  return (
    <>
      <div style={{ margin: 20 }}>
        <h1>{channel?.title}</h1>
        <h1>{channel?.subtitle}</h1>
        {channel?.type === ChannelType.MANUAL_BANK_TRANSFER ? (
          <>
            <Card
              style={{
                marginBottom: 10,
              }}
            >
              {vaNumber && (
                <div style={{ float: "left" }}>
                  <span
                    className="account-number-text-block"
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Nomor Rekening
                  </span>
                  <span
                    className="account-number"
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {vaNumber}
                  </span>
                  <br />
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#1677ff",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      message.info(`Nomor Rekening berhasil di salin.`);
                      navigator.clipboard.writeText(vaNumber);
                    }}
                  >
                    Salin Nomor Rekening
                  </span>
                </div>
              )}
            </Card>
            <Card
              hoverable
              style={{
                marginBottom: 10,
              }}
            >
              <p
                className="amount"
                style={{
                  fontWeight: "bold",
                }}
              >
                Jumlah
              </p>
              <div
                style={{
                  float: "right",
                }}
              >
                <span
                  className="amount-rp"
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  Rp{" "}
                </span>
                <span
                  className="amount-number"
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {thousandSeparator(totalAmount)}
                </span>
                <br />
                <span
                  style={{
                    cursor: "pointer",
                    color: "#1677ff",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    message.info(`Jumlah nominal berhasil disalin.`);
                    navigator.clipboard.writeText(`${totalAmount}`);
                  }}
                >
                  Salin Nominal
                </span>
              </div>
            </Card>
          </>
        ) : (
          <></>
        )}
        <Card hoverable title={"Perhatian"} style={{ marginBottom: 10 }}>
          {/* <span className="transaction-detail-text"></span> */}
          <span
            className="transaction-detail-description"
            style={{
              color: "#F0416C",
              fontSize: "14pt",
            }}
          >
            {process.env.REACT_APP_COMPANY_ID ===
              "ba4bc43d-bb0e-4902-acad-56e9c14c4ef4" ? (
              <b>
                PASTIKAN JUMLAH YANG DITRANSFER SESUAI DENGAN NOMINAL YANG
                TERCANTUM, UNTUK KEMUDAHAN PENDAFTARAN OTOMATIS OLEH SISTEM
              </b>
            ) : (
              <b>
                SILAKAN TRANSFER SESUAI NOMINAL YANG TERCANTUM DI ATAS.
                {process.env.REACT_APP_COMPANY_ID !==
                  "6520546e-20e5-4d59-94e5-15c334b28256"
                  ? `TIGA DIGIT
              KODE UNIK AKAN DIDONASIKAN UNTUK CAMPAIGN TERKAIT. PENGECEKAN TRANSFER MANUAL DIBUTUHKAN WAKTU MINIMAL 10 MENIT.`
                  : ""}
              </b>
            )}
          </span>
        </Card>
        {donationCartResult?.data?.map((item, index) => (
          <Card
            hoverable
            title={`Detail Transaksi #${index + 1}`}
            style={{ marginBottom: 10 }}
            key={index}
          >
            <span className="transaction-detail-text">Nama Produk</span>
            <span className="transaction-detail-description">
              {item.program_name}
            </span>
          </Card>
        ))}

        <Card
          hoverable
          title={"Upload Bukti Transfer"}
          style={{
            marginBottom: 10,
          }}
        >
          {uploading ? (
            <span>Loading...</span>
          ) : selectedFile !== null ? (
            <img
              src={`${process.env.REACT_APP_ASSETS_URL}/${selectedFile}`}
              alt="upload_proof_payment"
              style={{
                width: 250,
              }}
            />
          ) : (
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={(e) => {
                fileInputRef.current.click();
              }}
            >
              <FileAddOutlined
                style={{
                  fontSize: 32,
                }}
              />
              <span
                style={{
                  fontSize: 16,
                  fontWeight: "bold",
                }}
              >
                Upload Bukti Transfer
              </span>
              <input
                type="file"
                id="fileInput"
                onChange={handleFileChange}
                style={{ display: "none" }} // Hide the default file input
                ref={fileInputRef}
                accept="image/*"
              />
            </div>
          )}
          {/* <TrxModalComponent /> */}
        </Card>
        {selectedFile ? (
          <Card
            hoverable
            style={{
              marginBottom: 10,
            }}
          >
            <span>
              Bukti Transfer Berhasil di Upload, Transaksi anda sedang diproses.
            </span>
            <Button
              type="primary"
              onClick={(e) => {
                const url = `${process.env.REACT_APP_PLATFORM_DONATIONS}/payment/waiting`;
                window.location.href = url;
              }}
            >
              Selesai
            </Button>
          </Card>
        ) : null}
        {channel?.hows?.length > 0 ? (
          <Card
            hoverable
            title={"Cara Pembayaran"}
            style={{ marginBottom: 10 }}
          >
            <Tabs>
              {channel?.hows?.map((item, index) => (
                <Tabs.TabPane tab={item.name} key={index}>
                  {item.steps?.map((item, index) => (
                    <p key={index}>
                      {index + 1}. {item}
                    </p>
                  ))}
                </Tabs.TabPane>
              ))}
            </Tabs>
          </Card>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default PaymentCart;
